import { FC } from 'react'
import { SwaggerRoutes } from '../types'

interface AccordionRouteItemProps {
  route: SwaggerRoutes
  isSelected: boolean
  onToggle: (routeId: number) => void
  getMethodColor: (method: string) => string
}

export const AccordionRouteItem: FC<AccordionRouteItemProps> = ({
  route,
  isSelected,
  onToggle,
  getMethodColor,
}) => {
  return (
    <div className='mb-3'>
      <div
        className='d-flex gap-2 align-items-start p-2 border rounded'
        style={{ cursor: 'pointer' }}
      >
        <input
          className='form-check-input mt-1'
          type='checkbox'
          id={`route-${route.id}`}
          checked={isSelected}
          onChange={() => onToggle(route.id)}
          style={{ flexShrink: 0 }}
        />
        <label
          className='flex-grow-1'
          htmlFor={`route-${route.id}`}
          style={{ cursor: 'pointer' }}
        >
          <div className='d-flex gap-2 align-items-start'>
            <span
              className={`badge bg-${getMethodColor(route.method)} flex-shrink-0`}
            >
              {route.method}
            </span>
            <div className='flex-grow-1 small'>
              <div className='fw-bold text-break'>{route.url}</div>
              <div className='text-muted mb-1'>
                <span className='badge bg-light text-dark me-1'>
                  {route.operationId}
                </span>
              </div>
              {route.description && (
                <div className='text-muted fst-italic'>{route.description}</div>
              )}
              <div className='mt-1'>
                <span className='badge bg-light text-dark me-1'>
                  {route.resourceType}
                </span>
                {route.secured && (
                  <span className='badge bg-success me-1'>
                    <i className='fas fa-shield-alt me-1'></i>
                    Seguro
                  </span>
                )}
                {route.isAdminOnly && (
                  <span className='badge bg-warning text-dark me-1'>
                    <i className='fas fa-crown me-1'></i>
                    Admin
                  </span>
                )}
                <span
                  className={`badge bg-${route.status ? 'info' : 'secondary'}`}
                >
                  {route.status ? 'Ativo' : 'Inativo'}
                </span>
              </div>
            </div>
          </div>
        </label>
      </div>
    </div>
  )
}
